import {
  useSchoolSubscriptionPlansQuery,
  useUserSchoolSubscriptionQuery
} from "@pathwright/graphql-client/src/generated"
import useStripeProducts from "../stripe/graphql/useStripeProducts"
import { getIsSubscriptionActive } from "./utils"
import { useUserCommunityContext } from "../user/UserCommunityContext"

/**
 * Determines whether to show the "Subscribe" prompt in the left nav.
 * Matches the logic from the old AppPanel: show when the space has subscription
 * plans or Stripe products, and the user is neither already subscribed nor in
 * a community group with an active subscription.
 */
export function useShowSubscribePrompt(): boolean {
  const [stripeProducts] = useStripeProducts()
  const { communityGroupWithActiveSubscription, communityQuery } =
    useUserCommunityContext()
  const subscriptionPlansQuery = useSchoolSubscriptionPlansQuery()
  const userSubscriptionQuery = useUserSchoolSubscriptionQuery()

  const subscriptionPlansTotal =
    subscriptionPlansQuery.data?.school?.subscription_plans?.total ?? 0
  const hasPlans =
    subscriptionPlansTotal > 0 || (stripeProducts?.length ?? 0) > 0

  const userSubscription =
    userSubscriptionQuery.data?.me?.school_subscription?.subscription
  const userIsSubscribed =
    getIsSubscriptionActive(userSubscription) ||
    !!communityGroupWithActiveSubscription

  const checkingSubscriptionStatus =
    userSubscriptionQuery.loading || communityQuery.loading

  if (checkingSubscriptionStatus) return false

  return hasPlans && !userIsSubscribed
}
